<div class="dx-card wide-card">
    <h4 class="content-block ap-green">ASU/HYCO Awards SOG</h4>
    <div class="content-block">
        <dx-responsive-box singleColumnScreen="xs sm md">
            <dxi-row [ratio]="1"></dxi-row> <!--Year FIlter row -->
            
            <dxi-col [ratio]=".5"></dxi-col>
            <dxi-col [ratio]=".3"></dxi-col>
            <dxi-item>
                <dxi-location [row]="0" [col]="0"></dxi-location>
                <!-- <div class="dx-field">
                    <label text="Country">{{yearDropdownLabelText}}: </label>
                </div> -->
                <div class="dx-field">
                    <div class="dx-field-label"> {{yearDropdownLabelText}} </div>
                    <div class="dx-field-value">
                        <dx-select-box id="ddbCalendarYear" #ddbCalendarYear [dataSource]="ddbCaledarYearFilterDataSource"
                        displayExpr="announcementYear" valueExpr="id" [(value)]="defaultYearSelectionId"
                        [searchEnabled]="true" (onSelectionChanged)="onYearSelectionChanged($event)">
                    </dx-select-box>
                    </div>
                </div>
            </dxi-item>
            <dxi-item class="marginB10">
                <dxi-location [row]="0" [col]="1"></dxi-location>
                <div class="dx-field">
                    <dx-button class="ap-blue-btn" type="default" text="View Reports" (onClick)="viewReport()">
                    </dx-button>
                </div>
            </dxi-item>
        </dx-responsive-box>
        <hr />
        <h5 class="ap-green">{{pageTitle}}</h5>
    </div>
    <div class="content-block">
            <dx-tab-panel
                #crmOuterTabPanel
                [selectedIndex]="0"                
                [loop]="true"
                (onTitleClick)="renderReportPage($event)"
                [deferRendering]="false"
                [animationEnabled]="true"        
                [swipeEnabled]="false"       
                [visible]="true">
                
                <dxi-item [title]="'1-Yr Analysis'">
                    <app-o2-portal-hyco-oneyr-analysis-report [selectedReportLinkId]="selectedReportLinkId" [selectedAnnouncementYear]="selectedAnnouncementYear" [currentYearMonthsInfo]="currentYearMonthsInfo"></app-o2-portal-hyco-oneyr-analysis-report>
                </dxi-item>
                <dxi-item [title]="'5-Yr Analysis'">
                    <app-o2-portal-hyco-fiveyr-analysis-report [selectedReportLinkId]="selectedReportLinkId" [selectedAnnouncementYear]="selectedAnnouncementYear" [currentYearMonthsInfo]="currentYearMonthsInfo"></app-o2-portal-hyco-fiveyr-analysis-report>
                </dxi-item>
                <dxi-item [title]="'Regional Analysis'">
                    <app-o2-portal-hyco-regional-analysis-report [selectedReportLinkId]="selectedReportLinkId" [selectedAnnouncementYear]="selectedAnnouncementYear" [currentYearMonthsInfo]="currentYearMonthsInfo"></app-o2-portal-hyco-regional-analysis-report>
                </dxi-item>
                <dxi-item [title]="'Award Details'">
                    <app-o2-portal-hyco-award-details-report [selectedAnnouncementYear]="selectedAnnouncementYear"></app-o2-portal-hyco-award-details-report>
                </dxi-item>        
            </dx-tab-panel>
    </div>
</div>